export enum TicketsRoutesEnum {
    TICKET_PREFIX          = 'tickets',
    TICKETS_LIST           = 'tickets_list',
    TICKETS_DETAIL         = 'tickets_detail',
    TICKETS_GALLERY         = 'tickets_gallery',
    TICKETS_DETAIL_HISTORY = 'tickets_detail_history',
}
